import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, of } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { environment } from '../../environments/environment'

export interface VersionInfo {
  version: string
  name: string
  buildDateTime: string
  instanceName?: string
  instanceDescription?: string
}

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  constructor(private http: HttpClient) {}

  getVersionInfo(): Observable<VersionInfo> {
    return this.http.get<VersionInfo>('version.json').pipe(
      catchError((error) => {
        console.error('Error loading frontend version info:', error)
        return of({ version: '-', name: '-', buildDateTime: '-' })
      }),
    )
  }

  getVersion(): Observable<string> {
    return new Observable((observer) => {
      this.getVersionInfo().subscribe((info) => {
        observer.next(info.version)
        observer.complete()
      })
    })
  }

  getBackendVersion(): Observable<string> {
    return this.http.get<any>(environment.API_ENDPOINT).pipe(
      catchError((error) => {
        console.error('Error loading backend version:', error)
        return of('-')
      }),
    )
  }

  getBackendVersionInfo(): Observable<VersionInfo> {
    return this.http.get<VersionInfo>(environment.API_ENDPOINT).pipe(
      catchError((error) => {
        console.error('Error loading backend version info:', error)
        return of({ version: '-', name: '-', buildDateTime: '-' })
      }),
    )
  }
}
